export function formatILS(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "₪0";
  return `₪${Math.round(n).toLocaleString("he-IL")}`;
}

/** USD display-only: whole dollars via Math.round. Not for ILS SSOT or charge. */
export function formatUSD(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "$0";
  return `$${Math.round(n).toLocaleString("en-US")}`;
}

export function resolvePublicPackageDisplayPrice({
  priceIlsRaw,
  usdToIlsRate,
  roundingMethod = "Math.round",
} = {}) {
  const ils = Number(priceIlsRaw);
  if (!Number.isFinite(ils) || ils <= 0) {
    return {
      priceIlsRaw: null,
      priceUsdRaw: null,
      displayedIls: null,
      displayedUsd: null,
      roundingMethod,
      roundedIls: null,
    };
  }

  const roundedIls = Math.round(ils);
  const rate = Number(usdToIlsRate);
  const usdRaw =
    Number.isFinite(rate) && rate > 0 ? ils / rate : null;

  return {
    priceIlsRaw: ils,
    priceUsdRaw: usdRaw,
    displayedIls: formatILS(roundedIls),
    displayedUsd: usdRaw != null ? `(≈ ${formatUSD(usdRaw)})` : null,
    roundingMethod,
    roundedIls,
  };
}
